import classNames from "classnames";

import {SearchComboboxInfoIcon} from "../icons/SearchComboboxInfoIcon";
import type {ISearchComboboxBannerProps} from "../types/ISearchComboboxBannerProps";
import {SearchComboboxInlineOption} from "./SearchComboboxInlineOption";

import * as styles from "./SearchComboboxBanner.module.css";

/**
 * Note above the results ("Pokazujemy wyniki dla „łódź”"); the same anatomy carries the network error
 * with its "Spróbuj ponownie" action. The text is announced through the live region, not read from the listbox.
 */
export const SearchComboboxBanner = (props: ISearchComboboxBannerProps) => {
    const {icon, children, emphasis, action, className, dataTestId} = props;

    return (
        <div role="presentation" className={classNames(styles.banner, className)} data-testid={dataTestId}>
            <div className={styles.box}>
                <span className={styles.icon}>{icon ?? <SearchComboboxInfoIcon size={16} />}</span>
                <span className={styles.text}>
                    {children}
                    {emphasis ? (
                        <>
                            {" "}
                            <span className={styles.emphasis}>„{emphasis}”</span>
                        </>
                    ) : null}
                </span>
                {action ? <SearchComboboxInlineOption {...action} baseClassName={styles.action} activeClassName={styles.actionActive} /> : null}
            </div>
        </div>
    );
};
import classNames from "classnames";

import {SearchComboboxInfoIcon} from "../icons/SearchComboboxInfoIcon";
import type {ISearchComboboxBannerProps} from "../types/ISearchComboboxBannerProps";
import {SearchComboboxInlineOption} from "./SearchComboboxInlineOption";

import * as styles from "./SearchComboboxBanner.module.css";

/**
 * Note above the results ("Pokazujemy wyniki dla „łódź”"); the same anatomy carries the network error
 * with its "Spróbuj ponownie" action. The text is announced through the live region, not read from the listbox.
 */
export const SearchComboboxBanner = (props: ISearchComboboxBannerProps) => {
    const {icon, children, emphasis, action, className, dataTestId} = props;

    return (
        <div role="presentation" className={classNames(styles.banner, className)} data-testid={dataTestId}>
            <div className={styles.box}>
                <span className={styles.icon}>{icon ?? <SearchComboboxInfoIcon size={16} />}</span>
                <span className={styles.text}>
                    {children}
                    {emphasis ? (
                        <>
                            {" "}
                            <span className={styles.emphasis}>„{emphasis}”</span>
                        </>
                    ) : null}
                </span>
                {action ? <SearchComboboxInlineOption {...action} baseClassName={styles.action} activeClassName={styles.actionActive} /> : null}
            </div>
        </div>
    );
};
